export default "__VITE_ASSET__D26MyRZ4__"